declare global {
  interface Window {
    chatwootSDK?: {
      run: (config: { websiteToken: string; baseUrl: string }) => void
    }
    $chatwoot?: {
      toggle: (state?: 'open' | 'close') => void
      toggleBubbleVisibility: (state: 'hide' | 'show') => void
      setUser: (
        id: string | undefined,
        user: { email: string | undefined; name: string | undefined },
      ) => void
    }
  }
}

export const openChatwoot = (): void => {
  window.$chatwoot?.toggle('open')
}
